export default "__VITE_ASSET__6sYSdub$__"